import React from 'react'
import SettingsHeader from './SettingsHeader'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import SettingsFooter from './SettingsFooter'

import { LoaderIcon } from '@/app/features/icons/Loader'
import EditBusinessTripSettingsForm from './form/EditBusinessTripSettingsForm'
import { useEditBusinessTripForm } from '../../../context/EditBusinessTripFormContext'

const SettingsModal = ({ onClose }) => {
  const { handleSubmit, loading } = useEditBusinessTripForm()

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    handleSubmit()
  }

  return (
    <ModalLayout customZIndex={9999}>
      <form
        onSubmit={onSubmit}
        noValidate
        className="tw-relative tw-flex tw-max-h-[90vh] tw-w-full tw-max-w-[560px] tw-flex-col tw-rounded-lg tw-bg-white tw-shadow-2xl"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        {loading && (
          <div className="tw-absolute tw-inset-0 tw-z-[200] tw-grid tw-place-items-center tw-rounded-lg tw-bg-black/30 tw-backdrop-blur-sm">
            <LoaderIcon className="tw-animate-spin" />
          </div>
        )}
        <SettingsHeader onClose={onClose} />
        <EditBusinessTripSettingsForm />
        <SettingsFooter loading={loading} />
      </form>
    </ModalLayout>
  )
}

export default SettingsModal
